<template>
  <div class="account-permission section-main__content">
    <div class="header">
      <el-button type="primary" @click="save">{{ $t('account.button.save') }}</el-button>
      <el-button type="primary" @click="back">{{ $t('account.button.back') }}</el-button>
    </div>
    <!-- <el-row :gutter="1">
      <el-col :span="10" class="permission-content-left"></el-col>
      <el-col :span="13" class="permission-content-right"></el-col>
    </el-row> -->
    <div class="content">
      <div class="permission-content permission-content-left">
        <!-- <div class="area-search search">
          <el-input v-model="searchString" :placeholder="$t('area.placeholder.name')" clearable></el-input>
          <el-button type="primary" @click="filterText">{{ $t('area.button.query') }}</el-button>
          <el-button type="info" @click="clearArea">{{ $t('area.button.reset') }}</el-button>
        </div> -->
        <el-scrollbar class="scroll-bar">
          <el-tree
            v-if="showTree"
            ref="tree"
            class="tree-content"
            :data="tableData"
            :expand-on-click-node="false"
            node-key="id"
            show-checkbox
            :default-expanded-keys="expandedKeys"
            render-after-expand
            :props="treeProps"
            :highlight-current="true"
            :filter-node-method="filterNode"
            @node-click="nodeClick"
          >
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="permission-content permission-content-right">
        <div class="deviceList">
          <div class="device-search search">
            <el-input v-model="searchString" :placeholder="$t('area.placeholder.name')" clearable></el-input>
            <el-button type="primary" @click="filterText">{{ $t('area.button.query') }}</el-button>
            <el-button type="info" @click="clearArea">{{ $t('area.button.reset') }}</el-button>
          </div>
          <el-scrollbar class="list-scroll-bar">
            <div class="device">
              <el-table :data="deviceList" max-height="100%" stripe show-header>
                <el-table-column prop="deviceName" show-overflow-tooltip :label="$t('account.label.deviceName')"></el-table-column>
                <el-table-column prop="deviceTypeLabel" show-overflow-tooltip :filters="deviceTypeList" :filter-method="filterChange" filter-placement="right-start" column-key="deviceTypeLabel" :label="$t('account.label.deviceType')"></el-table-column>
                <el-table-column :label="$t('account.label.showPermission')">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox v-model="scope._self.showAll" :label="$t('account.label.showPermission')" @change="showChangeAll"></el-checkbox>
                  </template>
                  <template slot slot-scope="scope">
                    <el-checkbox v-model="scope.row.showPermission" @change="showChange(scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('account.label.operatePermission')">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox v-model="scope._self.controlAll" :label="$t('account.label.operatePermission')" @change="operateChangeAll"></el-checkbox>
                  </template>
                  <template slot slot-scope="scope">
                    <el-checkbox v-model="scope.row.operatePermission" @change="operateChange(scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="table-empty">
                    <img src="@/common/assets/images/empty.svg"/>
                    <p>{{$t('base.label.empty')}}</p>
                  </div>
                </template>
              </el-table>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '$utils';
import { api } from '../api'
export default {
  data() {
    return {
      title: '',
      visible: false,
      searchString: '',
      isDisabled: true,
      tableData: Object.freeze([]),
      deviceList: Object.freeze([]),
      deviceTypeList: [],
      showList: [],
      operateList: [],
      allDeviceList: [],
      areaNames: [],
      controlAll: false,
      showAll: false,
      showType: '',
      areIds: [],
      areaInfo: {
        index: '',
        id: '',
        father: '',
        lng: '',
        lat: '',
        name: '',
        desc: ''
      },
      // 展开的节点id
      expandedKeys: [],
      treeProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'isLeaf'
      },
      // 缓存全量树结构
      cacheTree: [],
      areaDetailsInfo: {},
      isTopTreeNode: true,
      showTree: true
    }
  },
  computed: {
    showAll1(val) {
      this.$log.debug(val);
      return this.showAll
    },
    controlAll1(val) {
      this.$log.debug(val);
      return this.controlAll
    }
  },
  created() {
    this.account = {};
    this.dicData = {};
    let dicList = utils.Dic.find('SENU006')
    this.$log.debug('Dic:', dicList);
    dicList.forEach(item => {
      this.dicData[item.value + ''] = item.label
    })
    if (this.$route && this.$route.query) {
      this.account = this.$route.query;
    }
    this.getAreaInfo()
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    getInfo(info) {
      this.$log.debug(2222222222);
    },
    // 检索树
    filterText() {
      // if (!this.searchString) {
      //   this.showTree = false;
      //   this.$nextTick(() => {
      //     this.showTree = true;
      //   });
      //   this.getAreaInfo();
      //   return;
      // }
      // this.$refs.tree.filter(this.searchString.trim());
      let typeList = this.deviceTypeList.map(r => r.value);
      this.$log.debug('typeList', typeList);
      this.deviceList = this.allDeviceList.filter(item => {
        item.showPermission = item.deviceRead === '1'
        item.operatePermission = item.deviceControl === '1'
        item.deviceTypeLabel = this.dicData[item.deviceType]
        if (typeList.indexOf(item.deviceType) === -1) {
          typeList.push(item.deviceType);
          this.deviceTypeList.push({
            text: item.deviceTypeLabel,
            value: item.deviceType
          });
        }
        return item.deviceName.toLowerCase().indexOf(this.searchString.trim().toLowerCase()) > -1;
      })
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {}
          entity.id = item.areaDevGroupCode
          entity.name = item.areaDevGroupName
          entity.lng = item.lng
          entity.lat = item.lat
          entity.desc = item.desc
          entity.isLeaf = !item.hasLeaf || !item.childrens
          if (item.childrens) {
            entity.children = self.menusDataPro(item.childrens)
          }
          result.push(entity);
        })
        return result;
      }
    },
    //获取区域列表
    getAreaInfo() {
      const self = this;
      let params = {
        'accountNumber': this.account.accountNumber
      }
      const account = utils.Cache.get('CACHE_USER_INFO');
      this.$fetch(api.permission.list, params).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        // const result = [{
        //   id: parentNode.areaDevGroupCode,
        //   name: parentNode.areaDevGroupName,
        //   lng: parentNode.lng,
        //   lat: parentNode.lat,
        //   desc: parentNode.desc,
        //   children: self.menusDataPro(response.returnObj.list)
        // }]
        self.cacheTree = result;
        self.tableData = Object.freeze(result)
        self.expandedKeys = [account.parkInfo.areaDevGroupCode];
      })
      // 根据账户组查询区域列表
      this.$fetch('cms/accountGroup/queryAreaDevGroup.json', {
        accoundCode: this.account.accountNumber
      }).then((response) => {
        if (response.returnObj === null || response.returnObj === undefined) {
          self.$refs.tree.setCheckedKeys([]);
        } else {
          self.areaDataMatch(response.returnObj)
          self.$refs.tree.setCheckedKeys(self.areIds);
        }
      })
    },
    areaDataMatch(data) {
      if (!(data instanceof Array) || data === undefined || data === null) {
        return null
      }
      const self = this
      data.forEach(function (item) {
        if (item.childrens) {
          self.areaDataMatch(item.childrens)
        } else {
          self.areIds.push(item.areaDevGroupCode)
        }
      })
    },
    filterChange(value, row, column) {
      // const property = column['property'];
      this.$log.debug(value);
      return row['deviceType'] === value;
    },
    // 单击节点时
    nodeClick(data) {
      // if (this.showType) {
      //   return;
      // }
      // this.isTopTreeNode = data.id !== '-1' ? false : true;
      // this.areaDetailsInfo = {
      //   id: data.id === '-1' ? '' : data.id,
      //   name: data.name,
      //   lng: data.lng,
      //   lat: data.lat,
      //   desc: data.desc
      // };
      this.$refs.tree.setChecked(data, true);
      const params = {
        areaIds: [data.id],
        accountNumber: this.account.accountNumber
      }
      this.$fetch(api.permission.queryDeviceList, params).then(resp => {
        if (resp.success) {
          let typeList = this.deviceTypeList.map(r => r.value);
          this.$log.debug('typeList', typeList);
          this.allDeviceList = resp.returnObj;
          this.deviceList = this.allDeviceList.map(item => {
            // item.showPermission = item.deviceRead === '1'
            // item.operatePermission = item.deviceControl === '1'
            // item.deviceTypeLabel = this.dicData[item.deviceType]
            this.$set(item, 'showPermission', item.deviceRead === '1')
            this.$set(item, 'operatePermission', item.deviceControl === '1')
            this.$set(item, 'deviceTypeLabel', this.dicData[item.deviceType])
            if (typeList.indexOf(item.deviceType) === -1) {
              typeList.push(item.deviceType);
              this.deviceTypeList.push({
                text: item.deviceTypeLabel,
                value: item.deviceType
              });
            }
            return item;
          })
          this.getAllNum()
        }
      })
    },
    showChangeAll(value) {
      // if (value) {
      //   this.deviceList.forEach(item => {
      //     item.showPermission = true;
      //   })
      // } else {
      //   }
      this.$log.debug('showChangeAll===>111111', value);
      // this.showAll = val;
      this.deviceList.forEach(item => {
        item.showPermission = value;
        if (!value) {
          item.operatePermission = value;
        }
      })
      if (!value) {
        this.controlAll = value;
      }
      this.$log.debug('showChangeAll===>222222', this.deviceList);
    },
    operateChangeAll(val) {
      this.$log.debug('operateChangeAll===>111111', val);
      // this.controlAll = val;
      // this.$set(this, 'controlAll', val);
      this.deviceList.forEach(item => {
        if (val) {
          item.showPermission = val;
        }
        item.operatePermission = val;
      })
      if (val) {
        this.showAll = val;
      }
      this.$log.debug('operateChangeAll===>222222', this.deviceList);
    },
    showChange(row, value) {
      // row.showPermission = value;
      if (!row.showPermission) {
        row.operatePermission = row.showPermission;
      }
      this.getAllNum();
    },
    operateChange(row, value) {
      if (row.operatePermission) {
        row.showPermission = row.operatePermission;
      }
      this.getAllNum()
      // row.operatePermission = value;
    },
    getAllNum() {
      const operateList = this.deviceList.filter(item => item.operatePermission)
      this.$log.debug('operateChange111:', operateList);
      this.$log.debug('operateChange222:', this.deviceList);
      if (operateList.length === this.deviceList.length && this.deviceList.length > 0) {
        this.$log.debug(1111)
        this.controlAll = true;
      } else {
        this.$log.debug(2222)
        this.controlAll = false
      }
      const showList = this.deviceList.filter(item => item.showPermission)
      this.$log.debug('showChange111:', showList);
      this.$log.debug('showChange222:', this.deviceList);
      if (showList.length === this.deviceList.length && this.deviceList.length > 0) {
        this.$log.debug('showChange==>33333:', this.showAll);
        this.showAll = true;
      } else {
        this.$log.debug('showChange==>44444:', this.showAll);
        this.showAll = false
      }
    },
    //重置
    clearArea() {
      this.searchString = '';
      this.areaNames = [];
      this.filterText();
    },
    back() {
      this.$router.back(-1);
    },
    save() {
      const nodes = this.$refs.tree.getCheckedKeys();
      this.$log.debug('nodes:', nodes);
      const deviceList = this.allDeviceList.map(device => {
        device.deviceRead = device.showPermission ? 1 : 0;
        device.deviceControl = device.operatePermission ? 1 : 0;
        return {
          deviceId: device.deviceId,
          deviceRead: device.deviceRead,
          deviceControl: device.deviceControl
        }
      })
      const areaParams = {
        accountCode: this.account.accountNumber,
        areaDevGroupCodes: nodes
      }
      const deviceParams = {
        accountCode: this.account.accountNumber,
        deviceList: deviceList
      }
      const setAreaList = this.$fetch(api.permission.setAreaList, areaParams);
      const setDeviceList = this.$fetch(api.permission.setDeviceList, deviceParams)
      Promise.all([setAreaList, setDeviceList]).then(response => {
        if (!response[0].success) {
          this.$message({
            type: 'error',
            duration: 2000,
            message: response[0].msgContent
          })
        } else if (!response[1].success) {
          this.$message({
            type: 'error',
            duration: 2000,
            message: response[1].msgContent
          })
        } else {
          this.$message({
            type: 'success',
            message: this.$t('accountGroup.message.setPermissionSuccess')
          })
          // this.back();
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.account-permission {
  width: 98%;
  height: 98%;
  position: relative;
  .header {
    margin: 10px auto;
    width: 98%;
  }
  .content {
    display: flex;
    box-sizing: border-box;
    width: 98%;
    height: 98%;
    margin: 0 auto;
    .area-search, .search {
      display: flex;
      margin-bottom: 20px;
      height: 28px;
      .el-input {
        margin-right: 10px;
        width: 200px;
      }
    }
  }
  .permission {
    &-content {
      @include set_theme_color(background-color, page-bg-color);
      &-left {
        padding: 20px 20px 0 20px;
        width: 330px;
        .scroll-bar {
          height: calc(100% - 48px);
          .el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
        .tree-content {
          .el-tree-node__label {
            display: inline-block;
            max-width: 80%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
        .tree-header {
          position: relative;
          background: #3f629c;
          color: #fff;
          font-weight: bold;
          font-size: 13px;
          .area-name {
            padding-left: 10px;
          }
        }
        .custom-info {
          position: absolute;
          display: inline-block;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .area-name {
          width: 80%;
        }
        .operate-btns {
          width: 20%;
          text-align: center;
          right: 10px;
        }
      }
      &-right {
        flex: 5;
        display: flex;
        margin-left: 18px;
        padding: 20px 20px 0 20px;
        .deviceList {
          flex: 1;
          display: flex;
          flex-direction: column;
          .device {
            flex: 1;
            display: flex;
          }
          .list-scroll-bar{
            height: calc(100% - 100px);
            .el-scrollbar__wrap {
              // overflow-x: hidden;
            }
          }
        }
        .el-table__body-wrapper {
          // height: calc(100% - 85px);
        }
      }
    }
  }
}
.el-table-filter {
    border: 1px solid #606266;
    border-radius: 2px;
    background-color: #0d121c;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 2px 0;
}
</style>